export default "__VITE_ASSET__D_lRDe4l__"